import React from 'react';
import { Divider, Icon, List } from 'semantic-ui-react';

const Description = () => {
    return (
        <List>
            <List.Item>
                <Icon name='world' />
                <List.Content>
                    <List.Header>Where am I from? Where am I?</List.Header>
                    <List.Description>I'm venezuelan, currently living in Chile.</List.Description>
                </List.Content>
                <Divider section></Divider>
                <Icon name='book' />
                <List.Content>
                    <List.Header>Did I study something in particular?</List.Header>
                    <List.Description>Hell yes! I'm a System Engineer at "Universidad de Los Andes" (ULA, Mérida - Venezuela).</List.Description>
                </List.Content>
                <Divider section></Divider>
                <Icon name='laptop' />
                <List.Content>
                    <List.Header>Any experience?</List.Header>
                    <List.Description>Currently working more on web development, both front-end and back-end (kind of full stack, yes) for over three years.
            <Divider horizontal></Divider>
                        Throughout my career I have used many technologies and tools, lately I am more focused on programming languages like javascript, python, golang.
            </List.Description>
                </List.Content>
            </List.Item>
        </List>
    );
};

export default Description;



// WEBPACK FOOTER //
// ./src/components/Description.js